<form *ngIf='form as form' [formGroup]='form' autocomplete='off' novalidate>
  <div class="row">
    <div class="col-12">
      <fieldset>
        <legend>
          {{ label }}
        </legend>
        <br>
        <fieldset>
          <legend>
            Termin umieszczenia w roku bieżącym
          </legend>
          <div class='row'>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"startDate" as controlName'>
                <label [for]='controlName'>
                  Data od *
                </label>
                <app-date-picker (change)="form.startDateChange($event)" [id]='controlName'
                                 [formControlName]='controlName'>
                </app-date-picker>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"endDate" as controlName'>
                <label [for]='controlName'>
                  Data do *
                </label>
                <app-date-picker (change)="form.endDateChange($event)" [id]='controlName'
                                 [formControlName]='controlName'>
                </app-date-picker>
                <app-validation-errors fieldLabel='Data od' secondFieldLabel='dacie do'
                                       [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-4">
              <div class='form-group' *ngIf='"dayQuantity" as controlName'>
                <label [for]='controlName'>
                  Ilość dni
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu ilość dni'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Termin umieszczenia w kolejnych latach
          </legend>
          <div class="row">
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"nextYearsFrom" as controlName'>
                <label [for]='controlName'>
                  Rok od
                </label>
                <select
                  (change)="form.calcYearsCount()"
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>Wybierz</option>
                  <option [value]='item' *ngFor='let item of form.yearList'>
                    {{ item }}
                  </option>
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-4'>
              <div class='form-group' *ngIf='"nextYearsTo" as controlName'>
                <label [for]='controlName'>
                  Rok do
                </label>
                <select
                  (change)="form.calcYearsCount()"
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'>
                  <option value=''>Wybierz</option>
                  <option [value]='item' *ngFor='let item of form.yearList'>
                    {{ item }}
                  </option>
                </select>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-4">
              <div class='form-group' *ngIf='"yearsCount" as controlName'>
                <label [for]='controlName'>
                  Ilość lat
                </label>
                <input
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu ilość lat'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Lokalizacja
          </legend>
          <br>
          <app-alert alertTittle="Uwaga!" [closable]="false">
            Aby powierzchnie zostały wyliczone automatycznie na podstawie narysowanego obszaru:
            <ol class="ms-4 mt-2">
              <li class="mb-2">
                Przejdź do funkcji <strong>GEOMETRIA</strong>
              </li>
              <li class="mb-2">
                Wybierz warstwę <strong>WIELOBOK</strong> i narysuj obszar na mapie.
              </li>
              <li class="mb-2">
                <strong>Wyślij geometrię.</strong> Po wysłaniu, w tabeli na końcu wniosku zostaną uzupełnione
                powierzchnie
                łączne. Sprawdź dane i w razie potrzeby popraw je ręcznie.
              </li>
            </ol>
          </app-alert>
          <div class="row">
            <div class="col-12">
              <div class='form-group' *ngIf='"infrastructureTelecommunicationOnly" as controlName'>
                <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                  <input
                    [formControlName]='controlName'
                    type='checkbox'
                    [id]='controlName'
                    [name]='controlName'>
                  <label [for]='controlName'>
                    Etap obowiązuje wyłącznie na zajęcie pasa w odniesieniu do obiektów i urządzeń infrastruktury
                    telekomunikacyjnej
                  </label>
                </div>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
          </div>
          <app-exposed-map-control
            #exposedMapContro
            (dictionary)="form.onLoadExposedMapDict($event)"
            [serviceId]="serviceId()"
            [control]="form.geometry">
          </app-exposed-map-control>
          <app-road-controls-set [expMapDict]="exposedMapContro.dictEvent()" [form]="form"></app-road-controls-set>
        </fieldset>
        <fieldset>
          <legend>
            Działki
          </legend>
          <div class="row">
            <div class="col-12">
              <app-parcels-crud
                expMapDictPlotType="Drogowa"
                [expMapDict]="exposedMapContro.dictEvent()"
                formControlName="parcels">
              </app-parcels-crud>
            </div>
          </div>
        </fieldset>
        <br>
        <div class="row">
          <div class="col-12">
            <app-alert alertTittle="Uwaga!" type="info" [closable]="false">
              Wypełnij min <strong>1</strong> z poniższych sekcji.
            </app-alert>
          </div>
        </div>
        <fieldset>
          <legend>
            Powierzchnia zajęcia na obiekcie mostowym
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"bridgeStructureWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcBridgeStructureArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"bridgeStructureLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcBridgeStructureArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"bridgeStructureArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="bridgeStructureWidth bridgeStructureLength bridgeStructureArea"
                [disabled]="!form.canClearBridgeStructureControls"
                (click)="form.clearBridgeStructureControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Powierzchnia zajęcia poza obiektem mostowym
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"outsideBridgeStructureWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcOutsideBridgeStructureArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"outsideBridgeStructureLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcOutsideBridgeStructureArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"outsideBridgeStructureArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="outsideBridgeStructureWidth outsideBridgeStructureLength outsideBridgeStructureArea"
                [disabled]="!form.canClearOutsideBridgeStructureControls"
                (click)="form.clearOutsideBridgeStructureControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
        <fieldset>
          <legend>
            Powierzchnia zajęcia w odniesieniu do obiektów i urządzeń infrastruktury
          </legend>
          <div class='row'>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"infrastructureEquipmentWidth" as controlName'>
                <label [for]='controlName'>
                  Szerokość (m)
                </label>
                <input
                  (change)='form.calcInfrastructureEquipmentArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu szerokość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"infrastructureEquipmentLength" as controlName'>
                <label [for]='controlName'>
                  Długość (m)
                </label>
                <input
                  (change)='form.calcInfrastructureEquipmentArea()'
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Wpisz tu długość'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class='col-md-3'>
              <div class='form-group' *ngIf='"infrastructureEquipmentArea" as controlName'>
                <label [for]='controlName'>
                  Powierzchnia (m<sup>2</sup>)
                </label>
                <input
                  mask='separator.2'
                  decimalMarker=','
                  [dropSpecialCharacters]='false'
                  [id]='controlName'
                  [ngClass]='{ "is-invalid": form.showError(controlName) }'
                  [formControlName]='controlName'
                  placeholder='Powierzchnia'
                  type='text'>
                <app-validation-errors [control]='form.get(controlName)'>
                </app-validation-errors>
              </div>
            </div>
            <div class="col-md-3 d-flex align-items-center">
              <button
                aria-controls="infrastructureEquipmentWidth infrastructureEquipmentLength infrastructureEquipmentArea"
                [disabled]="!form.canClearInfrastructureEquipmentControls"
                (click)="form.clearInfrastructureEquipmentControls()"
                title="Wyczyść wiersz"
                class="btn btn-tertiary mb-4 mb-md-0"
                type="button">
                <i class="fa fa-times" aria-hidden="true"></i>Wyczyść
              </button>
            </div>
          </div>
        </fieldset>
      </fieldset>
    </div>
  </div>
</form>
